import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
export const getAllPhones = createAsyncThunk(
  "PhoneNumbers/getAllPhones",
  async (data, thunkAPI) => {
    try {
      const resp = await axios.get(
        `${process.env.REACT_APP_BASE_URL}api/phone-config/numbers?pageNumber=${
          data.pageNumber || 1
        }&search=${data.search || ""}&pageSize=${data.pageSize || 25}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return resp.data?.data;
    } catch (error) {
      if (error.response) {
        return thunkAPI.rejectWithValue(
          error.response.data.errorMessage || error.response.data.message
        );
      } else {
        return thunkAPI.rejectWithValue(error.message);
      }
    }
  }
);
